import React, { useCallback } from 'react'

const ChartName = ({ chart }) => {
  const { stackDepth, position, vsAction, oppPosition, type, chartType } = chart
  const getTypeLabel = useCallback(() => {
    const typeValue = type || chartType

    if (!typeValue) return
    if (typeValue.toLowerCase().includes('cash')) return 'CASH'
    return 'TOURNEY'
  }, [type, chartType])

  return (
    <div
      className="ClearTheCharts__stats-label"
      style={{
        fontSize: '20px',
        textAlign: 'center',
        marginTop: '10px',
        marginBottom: '10px',
      }}
    >
      {getTypeLabel()} | {stackDepth}BBs | {position}{' '}
      {oppPosition === 'null' ? '' : `vs ${oppPosition || ''}`}
      {vsAction === 'null' ? '' : vsAction.replace('VS', '')}
    </div>
  )
}

export default ChartName
